/**
 * The questions the ask panel offers a reviewer.
 *
 * One file so the panel's chips and the "run on open" question (TRA-1081)
 * read the same text. The wording pushes toward evidence rather than a
 * verdict: the reviewer decides good or bad, the model goes and counts.
 */

/**
 * The question asked on open, and pre-filled in the composer (TRA-1081).
 *
 * Deliberately short. The team's own instructions (the gear, TRA-1082) say
 * what a review looks like; a long question fights them. On the Cartage
 * prod check (2026-09-09) the five-part question below produced four
 * paragraphs and hid the team's GOOD / BAD + Tags shape, while this one
 * produced exactly that shape, with `request N` links.
 */
export const RUN_ON_OPEN_QUESTION = 'Review this run.'

/**
 * The five-part standard question: what the agent was asked to do, whether
 * it finished, the main issue, where it is, and who it is for. Kept as an
 * explicit, evidence-first opener for teams running the default
 * instructions; the panel no longer sends it on open (see above).
 */
export const STANDARD_REVIEW_QUESTION =
  'What was the agent asked to do, and did it finish all of it? ' +
  'Name the main issue, if there is one, and the request it is in. ' +
  'Say who this run was for.'

/** The chips under the thread. Openers, in the order they appear. */
export const REVIEW_QUESTION_CHIPS: readonly string[] = [
  RUN_ON_OPEN_QUESTION,
  'What was the agent asked to do, and did it finish all of it?',
  'List every tool call that failed or returned an error.',
  'Where does the agent claim something the tool results do not confirm?',
]
